import { CSidebar } from './CSidebar.js';
import { CSidebarBrand } from './CSidebarBrand.js';
import { CSidebarFooter } from './CSidebarFooter.js';
import { CSidebarHeader } from './CSidebarHeader.js';
import { CSidebarNav } from './CSidebarNav.js';
import { CSidebarToggler } from './CSidebarToggler.js';

const CSidebarPlugin = {
    install: (app) => {
        app.component(CSidebar.name, CSidebar);
        app.component(CSidebarBrand.name, CSidebarBrand);
        app.component(CSidebarFooter.name, CSidebarFooter);
        app.component(CSidebarHeader.name, CSidebarHeader);
        app.component(CSidebarNav.name, CSidebarNav);
        app.component(CSidebarToggler.name, CSidebarToggler);
    },
};

export { CSidebar, CSidebarBrand, CSidebarFooter, CSidebarHeader, CSidebarNav, CSidebarPlugin, CSidebarToggler };
//# sourceMappingURL=index.js.map
